import ReactGA from "react-ga4";

const GA_MEASUREMENT_ID = process.env.REACT_APP_GA_MEASUREMENT_ID;

export const initGA = () => {
  if (!GA_MEASUREMENT_ID) {
    console.warn("GA Measurement ID is missing");
    return;
  }

  ReactGA.initialize(GA_MEASUREMENT_ID);
};

export const trackPageView = (path: string) => {
  ReactGA.event("page_view", {
    page_path: path,
  });
};

export const trackChatEvent = (
  event: string,
  params?: Record<string, string | number | boolean | undefined>
) => {
  if (!GA_MEASUREMENT_ID) return;
  ReactGA.event(event, params);
};
